/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AIExpressionCompletionResponse {
  Name: string
  Description: string
  Nodes: AIExpressionNodeCompletionResponse[]
  Edges: AIExpressionEdgeCreateRequest[]
}

export interface AIExpressionCreateRequest {
  /**
   * @minLength 1
   * @maxLength 128
   */
  Name: string
  /** @maxLength 512 */
  Description?: string | null
  /** @minItems 1 */
  Nodes: AIExpressionNodeCreateRequest[]
  Edges: AIExpressionEdgeCreateRequest[]
}

export interface AIExpressionDetailedResponse {
  /** @format int32 */
  Id: number
  Name: string
  Description?: string | null
  /** @format date-time */
  CreatedOn?: string | null
  IsCreatedByAI: boolean
  Nodes: AIExpressionNodeResponse[]
  Edges: AIExpressionEdgeResponse[]
}

export interface AIExpressionEdgeCreateRequest {
  /**
   * @format int32
   * @min 0
   * @max 1
   * @default 0
   */
  Order: number
  /** @minLength 1 */
  SourceNodeTag: string
  /** @minLength 1 */
  TargetNodeTag: string
}

export interface AIExpressionEdgeResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  Order: number
  /** @format int32 */
  SourceNodeId: number
  /** @format int32 */
  TargetNodeId: number
}

export interface AIExpressionExecuteRequest {
  /** @minLength 1 */
  ImageUrl: string
}

export interface AIExpressionNodeCompletionResponse {
  /** @format int32 */
  Id?: number | null
  Tag: string
  /** @format int32 */
  ClassId?: number | null
  /** @format int32 */
  ModelId?: number | null
  /**
   *
   *
   * 0 = Multiply
   *
   * 1 = Add
   *
   * 2 = Subtract
   */
  ArithmeticOperation?: ArithmeticOperation
  /**
   *
   *
   * 0 = And
   *
   * 1 = Or
   */
  LogicalOperation?: LogicalOperation
  /**
   *
   *
   * 0 = Count
   *
   * 1 = Max
   *
   * 2 = Min
   *
   * 3 = Sum
   */
  ReductionOperation?: ReductionOperation
  /**
   *
   *
   * 0 = Union
   *
   * 1 = Intersection
   */
  SetOperation?: SetOperation
  /**
   *
   *
   * 0 = Contains
   *
   * 1 = Matches
   *
   * 2 = Overlaps
   */
  BoundingBoxOperation?: BoundingBoxOperation
  /**
   *
   *
   * 0 = Equals
   *
   * 1 = NotEquals
   *
   * 2 = Greater
   *
   * 3 = GreaterOrEquals
   *
   * 4 = Less
   *
   * 5 = LessOrEquals
   */
  ComparisonOperation?: ComparisonOperation
  /** @maxLength 512 */
  StringValue?: string | null
  BooleanValue?: boolean | null
  /** @format int32 */
  IntegerValue?: number | null
  /**
   * @format double
   * @min -99999.99
   * @max 99999.99
   */
  X: number
  /**
   * @format double
   * @min -99999.99
   * @max 99999.99
   */
  Y: number
  /**
   *
   *
   * 1 = ClassFilter
   *
   * 2 = ModelRunner
   *
   * 3 = Reducer
   *
   * 4 = SetComposer
   *
   * 5 = LogicalValuesComposer
   *
   * 6 = ConstantNumber
   *
   * 7 = ConstantString
   *
   * 8 = ConstantBoolean
   *
   * 9 = PairSetComposer
   *
   * 10 = ReductionFilter
   *
   * 11 = Projector
   *
   * 12 = ValuesComparator
   *
   * 13 = ValuesCalculator
   */
  Type: AIExpressionNodeType
  /**
   *
   *
   * 1 = Boolean
   *
   * 2 = Date
   *
   * 3 = DateTime
   *
   * 4 = Decimal
   *
   * 5 = Float
   *
   * 6 = Integer
   *
   * 7 = String
   *
   * 8 = Set
   *
   * 9 = PairSet
   */
  ResultType: AIExpressionNodeResultType
  /** @format double */
  PredictionThreshold?: number | null
  /** @format double */
  IntersectionOverUnion?: number | null
  Class?: AIObjectResponse
  Model?: AIModelAttachResponse
}

export interface AIExpressionNodeCreateRequest {
  /** @format int32 */
  Id?: number | null
  Tag: string
  /** @format int32 */
  ClassId?: number | null
  /** @format int32 */
  ModelId?: number | null
  /**
   *
   *
   * 0 = Multiply
   *
   * 1 = Add
   *
   * 2 = Subtract
   */
  ArithmeticOperation?: ArithmeticOperation
  /**
   *
   *
   * 0 = And
   *
   * 1 = Or
   */
  LogicalOperation?: LogicalOperation
  /**
   *
   *
   * 0 = Count
   *
   * 1 = Max
   *
   * 2 = Min
   *
   * 3 = Sum
   */
  ReductionOperation?: ReductionOperation
  /**
   *
   *
   * 0 = Union
   *
   * 1 = Intersection
   */
  SetOperation?: SetOperation
  /**
   *
   *
   * 0 = Contains
   *
   * 1 = Matches
   *
   * 2 = Overlaps
   */
  BoundingBoxOperation?: BoundingBoxOperation
  /**
   *
   *
   * 0 = Equals
   *
   * 1 = NotEquals
   *
   * 2 = Greater
   *
   * 3 = GreaterOrEquals
   *
   * 4 = Less
   *
   * 5 = LessOrEquals
   */
  ComparisonOperation?: ComparisonOperation
  /** @maxLength 512 */
  StringValue?: string | null
  BooleanValue?: boolean | null
  /** @format int32 */
  IntegerValue?: number | null
  /**
   * @format double
   * @min -99999.99
   * @max 99999.99
   */
  X: number
  /**
   * @format double
   * @min -99999.99
   * @max 99999.99
   */
  Y: number
  /**
   *
   *
   * 1 = ClassFilter
   *
   * 2 = ModelRunner
   *
   * 3 = Reducer
   *
   * 4 = SetComposer
   *
   * 5 = LogicalValuesComposer
   *
   * 6 = ConstantNumber
   *
   * 7 = ConstantString
   *
   * 8 = ConstantBoolean
   *
   * 9 = PairSetComposer
   *
   * 10 = ReductionFilter
   *
   * 11 = Projector
   *
   * 12 = ValuesComparator
   *
   * 13 = ValuesCalculator
   */
  Type: AIExpressionNodeType
  /**
   *
   *
   * 1 = Boolean
   *
   * 2 = Date
   *
   * 3 = DateTime
   *
   * 4 = Decimal
   *
   * 5 = Float
   *
   * 6 = Integer
   *
   * 7 = String
   *
   * 8 = Set
   *
   * 9 = PairSet
   */
  ResultType: AIExpressionNodeResultType
  /** @format double */
  PredictionThreshold?: number | null
  /** @format double */
  IntersectionOverUnion?: number | null
}

export interface AIExpressionNodeResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  ClassId?: number | null
  Class?: AIObjectResponse
  /** @format int32 */
  ModelId?: number | null
  Model?: AIModelAttachResponse
  /**
   *
   *
   * 1 = Boolean
   *
   * 2 = Date
   *
   * 3 = DateTime
   *
   * 4 = Decimal
   *
   * 5 = Float
   *
   * 6 = Integer
   *
   * 7 = String
   *
   * 8 = Set
   *
   * 9 = PairSet
   */
  ResultType: AIExpressionNodeResultType
  StringValue: string
  BooleanValue?: boolean | null
  /** @format int32 */
  IntegerValue?: number | null
  /** @format double */
  X: number
  /** @format double */
  Y: number
  /**
   *
   *
   * 1 = ClassFilter
   *
   * 2 = ModelRunner
   *
   * 3 = Reducer
   *
   * 4 = SetComposer
   *
   * 5 = LogicalValuesComposer
   *
   * 6 = ConstantNumber
   *
   * 7 = ConstantString
   *
   * 8 = ConstantBoolean
   *
   * 9 = PairSetComposer
   *
   * 10 = ReductionFilter
   *
   * 11 = Projector
   *
   * 12 = ValuesComparator
   *
   * 13 = ValuesCalculator
   */
  Type: AIExpressionNodeType
  /**
   *
   *
   * 0 = Multiply
   *
   * 1 = Add
   *
   * 2 = Subtract
   */
  ArithmeticOperation?: ArithmeticOperation
  /**
   *
   *
   * 0 = Union
   *
   * 1 = Intersection
   */
  BoundingBoxOperation?: SetOperation
  /**
   *
   *
   * 0 = Equals
   *
   * 1 = NotEquals
   *
   * 2 = Greater
   *
   * 3 = GreaterOrEquals
   *
   * 4 = Less
   *
   * 5 = LessOrEquals
   */
  ComparisonOperation?: ComparisonOperation
  /**
   *
   *
   * 0 = And
   *
   * 1 = Or
   */
  LogicalOperation?: LogicalOperation
  /**
   *
   *
   * 0 = Count
   *
   * 1 = Max
   *
   * 2 = Min
   *
   * 3 = Sum
   */
  ReductionOperation?: ReductionOperation
  /**
   *
   *
   * 0 = Union
   *
   * 1 = Intersection
   */
  SetOperation?: SetOperation
  /** @format double */
  IntersectionOverUnion: number
  /** @format double */
  PredictionThreshold: number
}

/**
 *
 *
 * 1 = Boolean
 *
 * 2 = Date
 *
 * 3 = DateTime
 *
 * 4 = Decimal
 *
 * 5 = Float
 *
 * 6 = Integer
 *
 * 7 = String
 *
 * 8 = Set
 *
 * 9 = PairSet
 * @format int32
 */
export enum AIExpressionNodeResultType {
  Boolean = 1,
  Date = 2,
  DateTime = 3,
  Decimal = 4,
  Float = 5,
  Integer = 6,
  String = 7,
  Set = 8,
  PairSet = 9,
}

/**
 *
 *
 * 1 = ClassFilter
 *
 * 2 = ModelRunner
 *
 * 3 = Reducer
 *
 * 4 = SetComposer
 *
 * 5 = LogicalValuesComposer
 *
 * 6 = ConstantNumber
 *
 * 7 = ConstantString
 *
 * 8 = ConstantBoolean
 *
 * 9 = PairSetComposer
 *
 * 10 = ReductionFilter
 *
 * 11 = Projector
 *
 * 12 = ValuesComparator
 *
 * 13 = ValuesCalculator
 * @format int32
 */
export enum AIExpressionNodeType {
  ClassFilter = 1,
  ModelRunner = 2,
  Reducer = 3,
  SetComposer = 4,
  LogicalValuesComposer = 5,
  ConstantNumber = 6,
  ConstantString = 7,
  ConstantBoolean = 8,
  PairSetComposer = 9,
  ReductionFilter = 10,
  Projector = 11,
  ValuesComparator = 12,
  ValuesCalculator = 13,
}

export interface AIExpressionPredictionRequest {
  /** @maxLength 512 */
  Description: string
}

export interface AIExpressionResponse {
  /** @format int32 */
  Id: number
  Name: string
  Description?: string | null
  /** @format date-time */
  CreatedOn?: string | null
  IsCreatedByAI: boolean
}

export interface AIExpressionsPagedResponse {
  Expressions: AIExpressionResponse[]
  /** @format int32 */
  TotalCount: number
}

export interface AIModelAIObjectResponse {
  /** @format int32 */
  AIObjectId: number
  Name: string
  IsActive: boolean
  /** @format int32 */
  Threshold?: number | null
}

export interface AIModelAttachResponse {
  /** @format int32 */
  Id: number
  Name: string
  Description: string
  /** @format date-time */
  CreatedOn?: string | null
  /**
   *
   *
   * 0 = CustomVision
   *
   * 1 = External
   *
   * 2 = InternalTrained
   *
   * 3 = HuggingFace
   *
   * 4 = Roboflow
   */
  Type: AIModelType
  /** @format int32 */
  ProjectId?: number | null
  /** @format int32 */
  TenantId: number
}

export interface AIModelCreateRequest {
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
  Key?: string | null
  /**
   *
   *
   * 0 = CustomVision
   *
   * 1 = External
   *
   * 2 = InternalTrained
   *
   * 3 = HuggingFace
   *
   * 4 = Roboflow
   */
  Type: AIModelType
  RunOnPageUpload: boolean
  AIObjects: AIObjectPredictionSetUpdateRequest[]
}

export interface AIModelPublishRequest {
  /** @minItems 1 */
  TenantIds: number[]
}

/**
 *
 *
 * 0 = CustomVision
 *
 * 1 = External
 *
 * 2 = InternalTrained
 *
 * 3 = HuggingFace
 *
 * 4 = Roboflow
 * @format int32
 */
export enum AIModelType {
  CustomVision = 0,
  External = 1,
  InternalTrained = 2,
  HuggingFace = 3,
  Roboflow = 4,
}

export interface AIModelUpdateRequest {
  /** @format int32 */
  Id: number
  /** @format uri */
  Url?: string | null
  Key?: string | null
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
}

export interface AIObjectColorResponse {
  AIObjectName: string
  Color: string
}

export interface AIObjectForProjectResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format int32 */
  TotalCount: number
}

export interface AIObjectPredictionResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format int32 */
  Threshold?: number | null
  IsActive: boolean
  /** @format int32 */
  AIModelId: number
  /** @format int32 */
  AIModelAIObjectId: number
}

export interface AIObjectPredictionSetUpdateRequest {
  /** @format int32 */
  AIObjectId: number
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  Threshold: number
}

export interface AIObjectPropertyResponse {
  /** @format int32 */
  Id: number
  Name: string
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Ordinal: number
  /**
   *
   *
   * 0 = Json
   *
   * 1 = String
   *
   * 2 = IntNumber
   *
   * 3 = DoubleNumber
   *
   * 4 = DateTime
   *
   * 5 = Dropdown
   *
   * 6 = Checkbox
   *
   * 7 = Url
   *
   * 8 = Boolean
   *
   * 9 = Latitude
   *
   * 10 = Longitude
   */
  Type: AIObjectPropertyType
  DefaultValue: any
  IsDisabled: boolean
  IsEditable: boolean
  IsHidden: boolean
  /** @format int32 */
  SelectionListId?: number | null
  /**
   *
   *
   * 0 = None
   *
   * 1 = Height
   *
   * 2 = Width
   *
   * 3 = Depth
   *
   * 4 = Azimuth
   *
   * 5 = RollAngle
   *
   * 6 = Elevation
   *
   * 7 = PitchAngle
   *
   * 8 = HorizontalOffset
   *
   * 9 = VerticalOffset
   *
   * 10 = YawAngle
   */
  AutofillSource: AutofillSource
}

/**
 *
 *
 * 0 = Json
 *
 * 1 = String
 *
 * 2 = IntNumber
 *
 * 3 = DoubleNumber
 *
 * 4 = DateTime
 *
 * 5 = Dropdown
 *
 * 6 = Checkbox
 *
 * 7 = Url
 *
 * 8 = Boolean
 *
 * 9 = Latitude
 *
 * 10 = Longitude
 * @format int32
 */
export enum AIObjectPropertyType {
  Json = 0,
  String = 1,
  IntNumber = 2,
  DoubleNumber = 3,
  DateTime = 4,
  Dropdown = 5,
  Checkbox = 6,
  Url = 7,
  Boolean = 8,
  Latitude = 9,
  Longitude = 10,
}

export interface AIObjectResponse {
  /** @format int32 */
  Id: number
  Name: string
  Color: string
  /**
   *
   *
   * 0 = None
   *
   * 1 = Node
   *
   * 2 = Edge
   *
   * 3 = EdgeDirected
   */
  GraphElementType: GraphElementType
  IsProjectionEnabled: boolean
  /** @format int32 */
  ObjectLevel?: number | null
  /** @format date-time */
  CreatedOn?: string | null
  Properties: AIObjectPropertyResponse[]
}

export interface AIReportFilter {
  Value?: string | null
  /**
   *
   *
   * 0 = Unset
   *
   * 1 = Equals
   *
   * 2 = Contains
   *
   * 3 = NotEquals
   *
   * 4 = Empty
   *
   * 5 = NotEmpty
   */
  Operation?: FilterOperation
}

export interface AIReportSorting {
  /** @format int32 */
  Priority?: number | null
  /**
   *
   *
   * 0 = Unset
   *
   * 1 = Ascending
   *
   * 2 = Descending
   */
  Direction?: SortingDirection
}

export interface AnnotationAIObjectResponse {
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  AnnotationId: number
}

export interface AnnotationTextResponse {
  /** @format int32 */
  AnnotationId: number
  Text: string
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  UniqueAIObjectId?: number | null
}

export interface AnnotationUniqueAIObjectResponse {
  /** @format int32 */
  AnnotationId: number
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  UniqueAIObjectId: number
}

export interface ApiErrorResponse {
  Error: Error
}

/**
 *
 *
 * 0 = Multiply
 *
 * 1 = Add
 *
 * 2 = Subtract
 * @format int32
 */
export enum ArithmeticOperation {
  Multiply = 0,
  Add = 1,
  Subtract = 2,
}

/**
 *
 *
 * 0 = None
 *
 * 1 = Height
 *
 * 2 = Width
 *
 * 3 = Depth
 *
 * 4 = Azimuth
 *
 * 5 = RollAngle
 *
 * 6 = Elevation
 *
 * 7 = PitchAngle
 *
 * 8 = HorizontalOffset
 *
 * 9 = VerticalOffset
 *
 * 10 = YawAngle
 * @format int32
 */
export enum AutofillSource {
  None = 0,
  Height = 1,
  Width = 2,
  Depth = 3,
  Azimuth = 4,
  RollAngle = 5,
  Elevation = 6,
  PitchAngle = 7,
  HorizontalOffset = 8,
  VerticalOffset = 9,
  YawAngle = 10,
}

export interface BoundingBoxModel {
  /** @format double */
  X1: number
  /** @format double */
  X2: number
  /** @format double */
  Y1: number
  /** @format double */
  Y2: number
}

/**
 *
 *
 * 0 = Contains
 *
 * 1 = Matches
 *
 * 2 = Overlaps
 * @format int32
 */
export enum BoundingBoxOperation {
  Contains = 0,
  Matches = 1,
  Overlaps = 2,
}

/**
 *
 *
 * 0 = MLP
 *
 * 1 = LogisticRegression
 * @format int32
 */
export enum ClassifierType {
  MLP = 0,
  LogisticRegression = 1,
}

/**
 *
 *
 * 0 = Equals
 *
 * 1 = NotEquals
 *
 * 2 = Greater
 *
 * 3 = GreaterOrEquals
 *
 * 4 = Less
 *
 * 5 = LessOrEquals
 * @format int32
 */
export enum ComparisonOperation {
  Equals = 0,
  NotEquals = 1,
  Greater = 2,
  GreaterOrEquals = 3,
  Less = 4,
  LessOrEquals = 5,
}

export interface ContentForProjectResponse {
  /** @format int32 */
  Id: number
  Description: string
  /** @format int32 */
  TenantId: number
  /** @format date-time */
  CreatedOn?: string | null
  /** @format int32 */
  ContentStatus: number
  /** @format int32 */
  UserId: number
  ThumbnailUrl?: string | null
  IsPublished: boolean
  Owner: ContentOwnerForProjectResponse
  /** @format int32 */
  TotalCount: number
}

export interface ContentOwnerForProjectResponse {
  /** @format int32 */
  Id: number
  Name: string
  UserName: string
  FirstName: string
  LastName: string
  Email: string
}

export interface CreatePublishTemplateRequest {
  /** @format int32 */
  AIObjectId: number
  Columns: PublishTemplateColumnRequest[]
  Name: string
}

/**
 *
 *
 * 0 = NotDeployed
 *
 * 1 = Succeeded
 *
 * 2 = Stopped
 *
 * 3 = Failed
 *
 * 4 = Creating
 *
 * 5 = Updating
 *
 * 6 = Deleting
 *
 * 100 = SentToDeploy
 *
 * 101 = FailedToSendToDeploy
 * @format int32
 */
export enum DeploymentStatus {
  NotDeployed = 0,
  Succeeded = 1,
  Stopped = 2,
  Failed = 3,
  Creating = 4,
  Updating = 5,
  Deleting = 6,
  SentToDeploy = 100,
  FailedToSendToDeploy = 101,
}

export interface Detection {
  /** @format int32 */
  ClassId: number
  Name: string
  Color: string
  BoundingBox: BoundingBoxModel
  /** @format double */
  Probability: number
}

export interface Error {
  /** @format int32 */
  Code: number
  /** @minLength 1 */
  Message: string
  Details?: string | null
}

export interface ExpressionExecutionResult {
  TextResult?: string | null
  Result: any
  Detections: Detection[]
  Trace: Record<string, Trace>
}

/**
 *
 *
 * 0 = Unset
 *
 * 1 = Equals
 *
 * 2 = Contains
 *
 * 3 = NotEquals
 *
 * 4 = Empty
 *
 * 5 = NotEmpty
 * @format int32
 */
export enum FilterOperation {
  Unset = 0,
  Equals = 1,
  Contains = 2,
  NotEquals = 3,
  Empty = 4,
  NotEmpty = 5,
}

/**
 *
 *
 * 0 = Pending
 *
 * 1 = Pass
 *
 * 2 = Fail
 *
 * 3 = Empty
 *
 * 4 = ApprovedByAI
 *
 * 5 = RejectedByAI
 *
 * 6 = ApprovedByReviewer
 *
 * 7 = RejectedByReviewer
 * @format int32
 */
export enum FormAnswerStatus {
  Pending = 0,
  Pass = 1,
  Fail = 2,
  Empty = 3,
  ApprovedByAI = 4,
  RejectedByAI = 5,
  ApprovedByReviewer = 6,
  RejectedByReviewer = 7,
}

export interface FormControlForProjectResponse {
  /** @format int32 */
  Id: number
  Label: string
  FormName: string
  IconUrl?: string | null
  /** @format int32 */
  TotalCount: number
}

export interface FormControlNewTagCreateRequest {
  /** @format int32 */
  FormControlId: number
  /**
   * @minLength 0
   * @maxLength 500
   */
  Name: string
}

export interface FormControlTagCreateRequest {
  /** @format int32 */
  FormControlId: number
  /** @format int32 */
  TagId: number
  /** @format int32 */
  UserId?: number | null
  IsCreatedManually: boolean
  /** @format double */
  Probability?: number | null
}

export interface FormControlTagResponse {
  /** @format int32 */
  FormControlTagId: number
  /** @format int32 */
  FormControlId: number
  /** @format int32 */
  TagId: number
  Name: string
}

export interface FormForProjectResponse {
  /** @format int32 */
  Id: number
  Name: string
  IconUrl?: string | null
  /** @format date-time */
  CreatedOn?: string | null
  /** @format int32 */
  TotalCount: number
}

export interface GetAIObjectAnalysisRequest {
  Columns?: PublishTemplateColumnRequest[] | null
  Search?: string | null
  SearchFields?: string[] | null
}

export interface GetAIObjectsColorsRequest {
  AIObjectNames: string[]
}

export interface GetAnnotationAIObjectsRequest {
  AIObjectIds: number[]
  AnnotationIds: number[]
}

export interface GetAnnotationUniqueAIObjectsRequest {
  /** @minItems 1 */
  AnnotationIds: number[]
}

/**
 *
 *
 * 0 = None
 *
 * 1 = Node
 *
 * 2 = Edge
 *
 * 3 = EdgeDirected
 * @format int32
 */
export enum GraphElementType {
  None = 0,
  Node = 1,
  Edge = 2,
  EdgeDirected = 3,
}

/**
 *
 *
 * 0 = Unset
 *
 * 1 = Max
 *
 * 2 = Count
 * @format int32
 */
export enum GroupingOperation {
  Unset = 0,
  Max = 1,
  Count = 2,
}

export interface IterationAIObjectFilterResponse {
  /** @format int32 */
  Id: number
  Name: string
}

export type IterationAnnotationFiltersResponse = IterationFiltersResponse & {
  AIObjects: IterationAIObjectFilterResponse[]
  AnnotationOwners: IterationUserFilterResponse[]
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
}

export interface IterationContentFilterResponse {
  /** @format int32 */
  Id: number
  Description: string
}

export interface IterationDeployRequest {
  /** @format int32 */
  IterationId: number
}

export interface IterationDeployStartByAIModelRequest {
  /** @format int32 */
  AIModelId: number
}

export interface IterationDeployStartByVQAModelRequest {
  /** @format int32 */
  VQAModelId: number
}

/**
 *
 *
 * 1 = Annotations
 *
 * 2 = Forms
 * @format int32
 */
export enum IterationFilterType {
  Annotations = 1,
  Forms = 2,
}

export type IterationFiltersResponse = BaseIterationFiltersResponse &
  (
    | BaseIterationFiltersResponseTypeMapping<'IterationFormFiltersResponse', IterationFormFiltersResponse>
    | BaseIterationFiltersResponseTypeMapping<'IterationAnnotationFiltersResponse', IterationAnnotationFiltersResponse>
  )

export interface IterationFormControlFilterResponse {
  /** @format int32 */
  Id: number
  Label: string
}

export interface IterationFormFilterResponse {
  /** @format int32 */
  Id: number
  Name: string
}

export type IterationFormFiltersResponse = BaseIterationFiltersResponse & {
  Forms: IterationFormFilterResponse[]
  FormAnswerValue?: string | null
  FormAnswerStatuses: FormAnswerStatus[]
  Reviewers: IterationUserFilterResponse[]
  Approvers: IterationUserFilterResponse[]
  Answerers: IterationUserFilterResponse[]
  FormControls: IterationFormControlFilterResponse[]
}

export interface IterationMetricResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  MetricId: number
  /** @format int32 */
  IterationId: number
  /**
   * @minLength 1
   * @maxLength 255
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 255
   */
  XAxisName: string
  /**
   * @minLength 1
   * @maxLength 255
   */
  YAxisName: string
  Values: IterationMetricValueResponse[]
}

export interface IterationMetricValueResponse {
  /** @format int32 */
  X: number
  /** @format double */
  Y?: number | null
}

export interface IterationResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format int32 */
  Order: number
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = Starting
   *
   * 2 = Provisioning
   *
   * 3 = Preparing
   *
   * 4 = Queued
   *
   * 5 = Running
   *
   * 6 = Finalizing
   *
   * 7 = CancelRequested
   *
   * 8 = Completed
   *
   * 9 = Failed
   *
   * 10 = Canceled
   *
   * 11 = NotResponding
   *
   * 100 = SentToStart
   *
   * 101 = FailedToSendToStart
   */
  Status: IterationStatus
  ErrorMessage?: string | null
  WarningMessage?: string | null
  /**
   *
   *
   * 0 = NotDeployed
   *
   * 1 = Succeeded
   *
   * 2 = Stopped
   *
   * 3 = Failed
   *
   * 4 = Creating
   *
   * 5 = Updating
   *
   * 6 = Deleting
   *
   * 100 = SentToDeploy
   *
   * 101 = FailedToSendToDeploy
   */
  DeploymentStatus: DeploymentStatus
  /** @format date-time */
  DeploymentExpirationTime?: string | null
  /** @format int32 */
  UserId: number
  /** @format int32 */
  ProjectId: number
  /** @format date-time */
  StatusUpdatedOn?: string | null
  AnnotationOwnerIds: number[]
  /** @format date-time */
  AnnotationStartDate?: string | null
  /** @format date-time */
  AnnotationEndDate?: string | null
  ReviewerIds: number[]
  AnswererIds: number[]
  FormAnswerStatuses: FormAnswerStatus[]
  FormControlIds: number[]
  FormAnswerValue?: string | null
  ContentIds: number[]
  AIObjectIds: number[]
}

/**
 *
 *
 * 0 = NotStarted
 *
 * 1 = Starting
 *
 * 2 = Provisioning
 *
 * 3 = Preparing
 *
 * 4 = Queued
 *
 * 5 = Running
 *
 * 6 = Finalizing
 *
 * 7 = CancelRequested
 *
 * 8 = Completed
 *
 * 9 = Failed
 *
 * 10 = Canceled
 *
 * 11 = NotResponding
 *
 * 100 = SentToStart
 *
 * 101 = FailedToSendToStart
 * @format int32
 */
export enum IterationStatus {
  NotStarted = 0,
  Starting = 1,
  Provisioning = 2,
  Preparing = 3,
  Queued = 4,
  Running = 5,
  Finalizing = 6,
  CancelRequested = 7,
  Completed = 8,
  Failed = 9,
  Canceled = 10,
  NotResponding = 11,
  SentToStart = 100,
  FailedToSendToStart = 101,
}

/**
 *
 *
 * 1 = FineTuneCLIP
 *
 * 2 = ObjectDetection
 *
 * 3 = InstanceSegmentation
 *
 * 4 = ClassificationWithPretrainedEncoder
 *
 * 8 = ImageNLPClassificationWithPretrainedEncoder
 *
 * 9 = ObjectDetectionYolox
 * @format int32
 */
export enum IterationType {
  FineTuneCLIP = 1,
  ObjectDetection = 2,
  InstanceSegmentation = 3,
  ClassificationWithPretrainedEncoder = 4,
  ImageNLPClassificationWithPretrainedEncoder = 8,
  ObjectDetectionYolox = 9,
}

export interface IterationUpdateRequest {
  /** @format int32 */
  IterationId: number
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
}

export interface IterationUserFilterResponse {
  /** @format int32 */
  Id: number
  Name: string
}

/**
 *
 *
 * 0 = And
 *
 * 1 = Or
 * @format int32
 */
export enum LogicalOperation {
  And = 0,
  Or = 1,
}

export interface NLPModelCreateRequest {
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
}

export interface NLPModelResponse {
  /** @format int32 */
  Id: number
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
  /** @format int32 */
  TenantId: number
  /** @format date-time */
  CreatedOn?: string | null
}

export interface NLPModelUpdateRequest {
  /** @format int32 */
  Id: number
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
}

/**
 *
 *
 * 0 = YoloXSmall
 *
 * 1 = YoloXMedium
 *
 * 2 = YoloXLarge
 *
 * 3 = FasterRCNN50
 *
 * 4 = FasterRCNN101
 *
 * 5 = FasterRCNN101X
 *
 * 6 = MaskRCNN50
 *
 * 7 = MaskRCNN101
 *
 * 8 = MaskRCNN101X
 *
 * 9 = CascadeMaskRCNN50
 * @format int32
 */
export enum ObjectDetectorType {
  YoloXSmall = 0,
  YoloXMedium = 1,
  YoloXLarge = 2,
  FasterRCNN50 = 3,
  FasterRCNN101 = 4,
  FasterRCNN101X = 5,
  MaskRCNN50 = 6,
  MaskRCNN101 = 7,
  MaskRCNN101X = 8,
  CascadeMaskRCNN50 = 9,
}

export interface PageForIterationResponse {
  /** @format int32 */
  Id: number
  ThumbnailURL?: string | null
  Name: string
  /** @format int32 */
  ContentId: number
  IsActive: boolean
}

export interface PageForIterationResponsePaginatedPagesResponse {
  Pages: PageForIterationResponse[]
  /** @format int32 */
  TotalCount: number
}

export interface PagesStatisticsByAIObjectsForProjectGetRequest {
  ContentIds: number[]
  AIObjectIds: number[]
  UserIds: number[]
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
}

export interface PagesStatisticsByAIObjectsForProjectResponse {
  /** @format int32 */
  Id?: number | null
  Name?: string | null
  /** @format int32 */
  PagesCountAnnotationBbox: number
  /** @format int32 */
  PagesCountAnnotationPolygon: number
  /** @format int32 */
  PagesCountAnnotationClassification: number
  /** @format int32 */
  PagesCountAnnotationAll: number
  /** @format int32 */
  ItemsCountAnnotationBbox: number
  /** @format int32 */
  ItemsCountAnnotationPolygon: number
  /** @format int32 */
  ItemsCountAnnotationClassification: number
  /** @format int32 */
  ItemsCountAnnotationAll: number
}

export interface PagesStatisticsByFormsForProjectGetRequest {
  ContentIds: number[]
  FormIds: number[]
  ApproverIds: number[]
  ReviewerIds: number[]
  AnswererIds: number[]
  FormAnswerStatuses: FormAnswerStatus[]
  FormControlIds: number[]
  FormAnswerValue?: string | null
}

export interface PagesStatisticsByFormsForProjectResponse {
  /** @format int32 */
  Id?: number | null
  Name?: string | null
  /** @format int32 */
  PagesCountFormQuestions: number
  /** @format int32 */
  PagesCountNlpTags: number
  /** @format int32 */
  ItemsCountFormQuestions: number
  /** @format int32 */
  ItemsCountNlpTags: number
}

export interface PredictionSetUpdateRequest {
  /** @format int32 */
  Id: number
  RunOnPageUpload: boolean
  AIObjects: AIObjectPredictionSetUpdateRequest[]
}

export interface PredictionSetWithAIModelResponse {
  /** @format int32 */
  Id: number
  Key?: string | null
  /**
   *
   *
   * 0 = CustomVision
   *
   * 1 = External
   *
   * 2 = InternalTrained
   *
   * 3 = HuggingFace
   *
   * 4 = Roboflow
   */
  Type: AIModelType
  /** @format int32 */
  AIModelId: number
  /** @format date-time */
  UpdatedOn?: string | null
  RunOnPageUpload: boolean
  IsOwnModel: boolean
  Url: string
  Name: string
  Description: string
  /** @format date-time */
  CreatedOn?: string | null
  AIObjects: AIObjectPredictionResponse[]
}

/**
 *
 *
 * 0 = CLIP
 *
 * 1 = DinoV2Base
 *
 * 2 = SimCLR
 *
 * 3 = VitSmall
 *
 * 4 = ResnetRS50
 *
 * 5 = SwinTransformersBase
 *
 * 6 = ConvnextTiny
 * @format int32
 */
export enum PretrainedModelName {
  CLIP = 0,
  DinoV2Base = 1,
  SimCLR = 2,
  VitSmall = 3,
  ResnetRS50 = 4,
  SwinTransformersBase = 5,
  ConvnextTiny = 6,
}

export interface ProjectCreateRequest {
  /** @maxLength 500 */
  Name?: string | null
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
  /**
   *
   *
   * 0 = VQA
   *
   * 100 = ImageClassification
   *
   * 101 = ObjectDetection
   */
  Type: ProjectType
}

export interface ProjectResponse {
  /** @format int32 */
  Id: number
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
  /** @format int32 */
  UserId: number
  /**
   *
   *
   * 0 = VQA
   *
   * 100 = ImageClassification
   *
   * 101 = ObjectDetection
   */
  Type: ProjectType
  /** @format date-time */
  CreatedOn: string
}

export interface ProjectResponsePagenatedProjectsResponse {
  Projects: ProjectResponse[]
  /** @format int32 */
  TotalCount: number
}

export interface ProjectTrainStartRequest {
  ContentIds: number[]
  AIObjectIds: number[]
  FormIds: number[]
  UserIds: number[]
  ExcludedPageIds: number[]
  /** @format date-time */
  StartDate?: string | null
  /** @format date-time */
  EndDate?: string | null
  ApproverIds: number[]
  ReviewerIds: number[]
  AnswererIds: number[]
  FormAnswerStatuses: FormAnswerStatus[]
  FormControlIds: number[]
  FormAnswerValue?: string | null
  /** @format int32 */
  ProjectId: number
  /**
   *
   *
   * 1 = FineTuneCLIP
   *
   * 2 = ObjectDetection
   *
   * 3 = InstanceSegmentation
   *
   * 4 = ClassificationWithPretrainedEncoder
   *
   * 8 = ImageNLPClassificationWithPretrainedEncoder
   *
   * 9 = ObjectDetectionYolox
   */
  IterationType: IterationType
  AdvancedSettings: ProjectTrainingAdvancedSettingsRequest
}

export interface ProjectTrainingAdvancedSettingsRequest {
  /**
   * @format double
   * @min 0.1
   * @max 0.4
   */
  TestDataSize: number
  /**
   * @format int32
   * @min 1
   * @max 7
   */
  NumberOfCrossValidationFolds: number
  /**
   * @format int32
   * @min 2
   * @max 64
   */
  BatchSize: number
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  NumberOfEpochs: number
  /**
   * @format double
   * @max 0.1
   */
  LearningRate: number
  /**
   * @format double
   * @min 0.01
   * @max 0.99
   */
  ConfidenceThreshold: number
  /**
   *
   *
   * 0 = CLIP
   *
   * 1 = DinoV2Base
   *
   * 2 = SimCLR
   *
   * 3 = VitSmall
   *
   * 4 = ResnetRS50
   *
   * 5 = SwinTransformersBase
   *
   * 6 = ConvnextTiny
   */
  PretrainedModelName: PretrainedModelName
  /**
   *
   *
   * 0 = MLP
   *
   * 1 = LogisticRegression
   */
  ClassifierType: ClassifierType
  /**
   * @format double
   * @min 0.0001
   * @max 0.01
   */
  EarlyStoppingMinDelta: number
  /**
   * @format int32
   * @min 1
   * @max 10
   */
  EarlyStoppingPatience: number
  /**
   *
   *
   * 0 = YoloXSmall
   *
   * 1 = YoloXMedium
   *
   * 2 = YoloXLarge
   *
   * 3 = FasterRCNN50
   *
   * 4 = FasterRCNN101
   *
   * 5 = FasterRCNN101X
   *
   * 6 = MaskRCNN50
   *
   * 7 = MaskRCNN101
   *
   * 8 = MaskRCNN101X
   *
   * 9 = CascadeMaskRCNN50
   */
  ObjectDetector: ObjectDetectorType
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  TextEncoderLayersPercent: number
  /**
   * @format int32
   * @min 0
   * @max 100
   */
  ImageEncoderLayersPercent: number
}

export interface ProjectTrainingMetricsRequest {
  /** @minLength 1 */
  Name: string
  /** @minItems 1 */
  Values: (number | null)[]
}

export interface ProjectTrainingUpdateDeploymentStatusRequest {
  /** @format int32 */
  ProjectId?: number | null
  /** @format int32 */
  IterationId: number
  Url?: string | null
  Key?: string | null
  /**
   *
   *
   * 0 = NotDeployed
   *
   * 1 = Succeeded
   *
   * 2 = Stopped
   *
   * 3 = Failed
   *
   * 4 = Creating
   *
   * 5 = Updating
   *
   * 6 = Deleting
   *
   * 100 = SentToDeploy
   *
   * 101 = FailedToSendToDeploy
   */
  Status: DeploymentStatus
  /** @format date-time */
  ExpirationTime?: string | null
  ErrorMessage?: string | null
  WarningMessage?: string | null
}

export interface ProjectTrainingUpdateStatusRequest {
  /** @format int32 */
  ProjectId: number
  /** @format int32 */
  IterationId: number
  /**
   *
   *
   * 0 = NotStarted
   *
   * 1 = Starting
   *
   * 2 = Provisioning
   *
   * 3 = Preparing
   *
   * 4 = Queued
   *
   * 5 = Running
   *
   * 6 = Finalizing
   *
   * 7 = CancelRequested
   *
   * 8 = Completed
   *
   * 9 = Failed
   *
   * 10 = Canceled
   *
   * 11 = NotResponding
   *
   * 100 = SentToStart
   *
   * 101 = FailedToSendToStart
   */
  Status: IterationStatus
  ErrorMessage?: string | null
  WarningMessage?: string | null
  /** @format date-time */
  EventTime: string
  Metrics?: ProjectTrainingMetricsRequest[] | null
}

/**
 *
 *
 * 0 = VQA
 *
 * 100 = ImageClassification
 *
 * 101 = ObjectDetection
 * @format int32
 */
export enum ProjectType {
  VQA = 0,
  ImageClassification = 100,
  ObjectDetection = 101,
}

export interface ProjectUpdateRequest {
  /** @format int32 */
  Id: number
  /**
   * @minLength 0
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 0
   * @maxLength 1000
   */
  Description: string
}

/**
 *
 *
 * 1 = Name
 *
 * 2 = Description
 *
 * 3 = CreatedOn
 *
 * 4 = Type
 * @format int32
 */
export enum ProjectsSortingColumnEnum {
  Name = 1,
  Description = 2,
  CreatedOn = 3,
  Type = 4,
}

export interface PublishAIReportRequest {
  /** @format int32 */
  TemplateId?: number | null
  Name: string
  Rewrite: boolean
}

export interface PublishTemplateColumnRequest {
  /** @format int32 */
  Id?: number | null
  Property: string
  Sorting?: AIReportSorting
  Filter?: AIReportFilter
  /**
   *
   *
   * 0 = Unset
   *
   * 1 = Max
   *
   * 2 = Count
   */
  Grouping: GroupingOperation
}

/**
 *
 *
 * 0 = Count
 *
 * 1 = Max
 *
 * 2 = Min
 *
 * 3 = Sum
 * @format int32
 */
export enum ReductionOperation {
  Count = 0,
  Max = 1,
  Min = 2,
  Sum = 3,
}

export interface SelectionListCreateRequest {
  /**
   * @minLength 0
   * @maxLength 100
   */
  Name: string
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   *
   * 2 = Disabled
   */
  Status: SelectionListStatus
  /** @minItems 1 */
  Items: SelectionListItemCreateRequest[]
}

export interface SelectionListItemCreateRequest {
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Ordinal: number
  /**
   * @minLength 0
   * @maxLength 250
   */
  Value: string
  IsDisabled: boolean
}

export interface SelectionListItemResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  SelectionListId: number
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Ordinal: number
  /**
   * @minLength 1
   * @maxLength 250
   */
  Value: string
  IsDisabled: boolean
  /** @format date-time */
  CreatedOn: string
  /** @format date-time */
  DisabledOn?: string | null
}

export interface SelectionListItemUpdateRequest {
  /** @format int32 */
  Id?: number | null
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  Ordinal: number
  /**
   * @minLength 0
   * @maxLength 250
   */
  Value: string
  IsDisabled: boolean
}

export interface SelectionListResponse {
  /** @format int32 */
  Id: number
  /**
   * @minLength 1
   * @maxLength 100
   */
  Name: string
  /** @format int32 */
  TenantId: number
  /** @format int32 */
  OwnerId: number
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   *
   * 2 = Disabled
   */
  Status: SelectionListStatus
  /** @format date-time */
  CreatedOn: string
  Items: SelectionListItemResponse[]
}

/**
 *
 *
 * 0 = Draft
 *
 * 1 = Published
 *
 * 2 = Disabled
 * @format int32
 */
export enum SelectionListStatus {
  Draft = 0,
  Published = 1,
  Disabled = 2,
}

export interface SelectionListUpdateRequest {
  /**
   * @minLength 0
   * @maxLength 100
   */
  Name: string
  /**
   *
   *
   * 0 = Draft
   *
   * 1 = Published
   *
   * 2 = Disabled
   */
  Status: SelectionListStatus
  /** @minItems 1 */
  Items: SelectionListItemUpdateRequest[]
}

/**
 *
 *
 * 0 = Union
 *
 * 1 = Intersection
 * @format int32
 */
export enum SetOperation {
  Union = 0,
  Intersection = 1,
}

/**
 *
 *
 * 0 = Unset
 *
 * 1 = Ascending
 *
 * 2 = Descending
 * @format int32
 */
export enum SortingDirection {
  Unset = 0,
  Ascending = 1,
  Descending = 2,
}

/**
 *
 *
 * 1 = asc
 *
 * 2 = desc
 * @format int32
 */
export enum SortingOrder {
  Asc = 1,
  Desc = 2,
}

/**
 *
 *
 * 0 = Metric
 *
 * 1 = Imperial
 *
 * 2 = OutOfSystem
 * @format int32
 */
export enum SystemOfMeasureTypes {
  Metric = 0,
  Imperial = 1,
  OutOfSystem = 2,
}

export interface TagCreateRequest {
  /**
   * @minLength 0
   * @maxLength 500
   */
  Name: string
}

export interface TagResponse {
  /** @format int32 */
  Id: number
  Name: string
  /**
   *
   *
   * 1 = Object
   *
   * 2 = Intent
   *
   * 3 = Cable
   *
   * 4 = View
   *
   * 5 = Value
   *
   * 6 = ManuallyCreated
   */
  Type: TagType
}

/**
 *
 *
 * 1 = Object
 *
 * 2 = Intent
 *
 * 3 = Cable
 *
 * 4 = View
 *
 * 5 = Value
 *
 * 6 = ManuallyCreated
 * @format int32
 */
export enum TagType {
  Object = 1,
  Intent = 2,
  Cable = 3,
  View = 4,
  Value = 5,
  ManuallyCreated = 6,
}

export interface TenantResponse {
  /** @format int32 */
  Id: number
  /** @minLength 1 */
  Name: string
}

export interface Trace {
  /** @format date-span */
  ExecutionTime: string
  Result: any
}

export interface UniqueAIObjectBaseResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  UserId: number
  /** @format date-time */
  CreatedOn?: string | null
}

export interface UniqueAIObjectChildConnectionResponse {
  /** @format int32 */
  Id: number
  Child: UniqueAIObjectBaseResponse
  /**
   *
   *
   * 0 = Link
   *
   * 1 = Projection
   *
   * 2 = Intersection
   */
  Type: UniqueAIObjectConnectionType
  /** @format date-time */
  CreatedOn: string
}

/**
 *
 *
 * 0 = Link
 *
 * 1 = Projection
 *
 * 2 = Intersection
 * @format int32
 */
export enum UniqueAIObjectConnectionType {
  Link = 0,
  Projection = 1,
  Intersection = 2,
}

export interface UniqueAIObjectExternalUpdateRequest {
  /** @format int32 */
  Id: number
  /** @minLength 1 */
  Properties: string
  Name?: string | null
}

export interface UniqueAIObjectParentConnectionResponse {
  /** @format int32 */
  Id: number
  Parent: UniqueAIObjectBaseResponse
  /**
   *
   *
   * 0 = Link
   *
   * 1 = Projection
   *
   * 2 = Intersection
   */
  Type: UniqueAIObjectConnectionType
  /** @format date-time */
  CreatedOn: string
}

export interface UniqueAIObjectPropertyResponse {
  /** @format int32 */
  Id: number
  AIObjectPropertyName: string
  /** @format int32 */
  AIObjectPropertyId: number
  /** @format int32 */
  UniqueAIObjectId: number
  /** @format int32 */
  Ordinal: number
  Value?: any
  /** @format date-time */
  CreatedOn: string
}

export interface UniqueAIObjectResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  UserId: number
  /** @format date-time */
  CreatedOn?: string | null
  Properties: UniqueAIObjectPropertyResponse[]
  ParentConnections: UniqueAIObjectParentConnectionResponse[]
  ChildConnections: UniqueAIObjectChildConnectionResponse[]
}

export interface UniqueAIObjectWithAIObjectResponse {
  /** @format int32 */
  Id: number
  Name: string
  /** @format int32 */
  AIObjectId: number
  /** @format int32 */
  UserId: number
  /** @format date-time */
  CreatedOn?: string | null
  AIObjectName: string
}

export interface UniqueAIObjectsAutofillRequest {
  /** @format int32 */
  PageId: number
  /**
   *
   *
   * 0 = Metric
   *
   * 1 = Imperial
   *
   * 2 = OutOfSystem
   */
  Unit: SystemOfMeasureTypes
  UniqueAIObjectIds: number[]
}

export interface UpdatePublishTemplateRequest {
  Columns: PublishTemplateColumnRequest[]
  Name: string
}

export interface UtilityInfrastructureAnalysisRequest {
  /** @minItems 1 */
  UniqueAiObjectsIds: number[]
  /** @format int32 */
  ContentId: number
}

export interface VQAModelCreateRequest {
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
}

export interface VQAModelFormResponse {
  /** @format int32 */
  Id: number
  /** @format int32 */
  FormId: number
  VQAModel: VQAModelShortResponse
}

export interface VQAModelListResponse {
  /** @format int32 */
  Id: number
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
  /** @format int32 */
  TenantId: number
  /** @format date-time */
  CreatedOn?: string | null
  /**
   *
   *
   * 0 = External
   *
   * 1 = InternalTrained
   */
  Type: VQAModelType
  /** @format int32 */
  ProjectId?: number | null
  /**
   *
   *
   * 0 = NotDeployed
   *
   * 1 = Succeeded
   *
   * 2 = Stopped
   *
   * 3 = Failed
   *
   * 4 = Creating
   *
   * 5 = Updating
   *
   * 6 = Deleting
   *
   * 100 = SentToDeploy
   *
   * 101 = FailedToSendToDeploy
   */
  DeploymentStatus?: DeploymentStatus
  /** @format date-time */
  DeploymentExpirationTime?: string | null
  PublishedToTenants: TenantResponse[]
}

export interface VQAModelResponse {
  /** @format int32 */
  Id: number
  /**
   * @format uri
   * @minLength 1
   */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
  /** @format int32 */
  TenantId: number
  /** @format date-time */
  CreatedOn?: string | null
  /**
   *
   *
   * 0 = External
   *
   * 1 = InternalTrained
   */
  Type: VQAModelType
}

export interface VQAModelShortResponse {
  /** @format int32 */
  Id: number
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
}

/**
 *
 *
 * 0 = External
 *
 * 1 = InternalTrained
 * @format int32
 */
export enum VQAModelType {
  External = 0,
  InternalTrained = 1,
}

export interface VQAModelUpdateRequest {
  /** @format int32 */
  Id: number
  /** @format uri */
  Url: string
  /**
   * @minLength 1
   * @maxLength 500
   */
  Name: string
  /**
   * @minLength 1
   * @maxLength 1000
   */
  Description: string
}

interface BaseIterationFiltersResponse {
  /**
   *
   *
   * 1 = Annotations
   *
   * 2 = Forms
   */
  Type: IterationFilterType
  Contents: IterationContentFilterResponse[]
}

type BaseIterationFiltersResponseTypeMapping<Key, Type> = {
  Type: Key
} & Type

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from 'axios'
import axios from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://api-dev.collaborate.center/ai/ai-service/',
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body)
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data)
  }
}

/**
 * @title Tabeeb.AIMicroservice
 * @version v1
 * @baseUrl https://api-dev.collaborate.center/ai/ai-service/
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  aiExpressions = {
    /**
     * No description
     *
     * @tags AIExpressions
     * @name GetAllAsync
     * @request GET:/api/ai-expressions
     * @secure
     */
    getAllAsync: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @max 2147483647
         * @default 0
         */
        skip?: number
        /**
         * @format int32
         * @min 0
         * @max 100
         * @default 50
         */
        take?: number
        search?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AIExpressionsPagedResponse, ApiErrorResponse>({
        path: `/ai-service/api/ai-expressions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIExpressions
     * @name CreateAsync
     * @request POST:/api/ai-expressions
     * @secure
     */
    createAsync: (data: AIExpressionCreateRequest, params: RequestParams = {}) =>
      this.http.request<AIExpressionResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-expressions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIExpressions
     * @name GetAsync
     * @request GET:/api/ai-expressions/{expressionId}
     * @secure
     */
    getAsync: (expressionId: number, params: RequestParams = {}) =>
      this.http.request<AIExpressionDetailedResponse, ApiErrorResponse>({
        path: `/ai-service/api/ai-expressions/${expressionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIExpressions
     * @name UpdateAsync
     * @request PUT:/api/ai-expressions/{expressionId}
     * @secure
     */
    updateAsync: (expressionId: number, data: AIExpressionCreateRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-expressions/${expressionId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIExpressions
     * @name DeleteAsync
     * @request DELETE:/api/ai-expressions/{expressionId}
     * @secure
     */
    deleteAsync: (expressionId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/ai-service/api/ai-expressions/${expressionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIExpressions
     * @name ExecuteAsync
     * @request POST:/api/ai-expressions/{expressionId}/execute
     * @secure
     */
    executeAsync: (expressionId: number, data: AIExpressionExecuteRequest, params: RequestParams = {}) =>
      this.http.request<ExpressionExecutionResult, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-expressions/${expressionId}/execute`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIExpressions
     * @name GenerateByDescriptionAsync
     * @request POST:/api/ai-expressions/generate
     * @secure
     */
    generateByDescriptionAsync: (data: AIExpressionPredictionRequest, params: RequestParams = {}) =>
      this.http.request<AIExpressionCompletionResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-expressions/generate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  aiModels = {
    /**
     * No description
     *
     * @tags AIModels
     * @name PostAsync
     * @request POST:/api/ai-models
     * @secure
     */
    postAsync: (data: AIModelCreateRequest, params: RequestParams = {}) =>
      this.http.request<PredictionSetWithAIModelResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-models`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIModels
     * @name PutAsync
     * @request PUT:/api/ai-models
     * @secure
     */
    putAsync: (data: AIModelUpdateRequest, params: RequestParams = {}) =>
      this.http.request<AIModelUpdateRequest, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-models`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIModels
     * @name DeleteAsync
     * @request DELETE:/api/ai-models/{aiModelId}
     * @secure
     */
    deleteAsync: (aiModelId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/ai-service/api/ai-models/${aiModelId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIModels
     * @name PublishAsync
     * @request POST:/api/ai-models/{aiModelId}/publish
     * @secure
     */
    publishAsync: (aiModelId: number, data: AIModelPublishRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-models/${aiModelId}/publish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIModels
     * @name UnpublishAsync
     * @request POST:/api/ai-models/{aiModelId}/unpublish
     * @secure
     */
    unpublishAsync: (aiModelId: number, data: AIModelPublishRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/ai-models/${aiModelId}/unpublish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  aiObjects = {
    /**
     * No description
     *
     * @tags AIObjects
     * @name GetAllAsync
     * @request GET:/api/ai-objects
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<AIObjectResponse[], any>({
        path: `/ai-service/api/ai-objects`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIObjects
     * @name GetByAiModelAsync
     * @request GET:/api/ai-objects/ai-model/{aiModelId}
     * @secure
     */
    getByAiModelAsync: (aiModelId: number, params: RequestParams = {}) =>
      this.http.request<AIModelAIObjectResponse, ApiErrorResponse>({
        path: `/ai-service/api/ai-objects/ai-model/${aiModelId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIObjects
     * @name GetByIdAsync
     * @request GET:/api/ai-objects/{aiObjectId}
     * @secure
     */
    getByIdAsync: (aiObjectId: number, params: RequestParams = {}) =>
      this.http.request<AIObjectResponse, ApiErrorResponse>({
        path: `/ai-service/api/ai-objects/${aiObjectId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIObjects
     * @name GetAllTenantAiObjectsForProjectAsync
     * @request GET:/api/ai-objects/project
     * @secure
     */
    getAllTenantAiObjectsForProjectAsync: (
      query?: {
        /** @format int32 */
        pageNumber?: number
        /** @format int32 */
        pageSize?: number
        searchQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<AIObjectForProjectResponse[], any>({
        path: `/ai-service/api/ai-objects/project`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIObjects
     * @name GetAiObjectsColorsAsync
     * @request POST:/api/ai-objects/colors
     * @secure
     */
    getAiObjectsColorsAsync: (data: GetAIObjectsColorsRequest, params: RequestParams = {}) =>
      this.http.request<AIObjectColorResponse[], ApiErrorResponse | void>({
        path: `/ai-service/api/ai-objects/colors`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIObjects
     * @name GetLastUpdateTimeAsync
     * @request GET:/api/ai-objects/last-update-time
     * @secure
     */
    getLastUpdateTimeAsync: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/ai-service/api/ai-objects/last-update-time`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  aiReportPublishTemplate = {
    /**
     * No description
     *
     * @tags AIReportPublishTemplate
     * @name GetAsync
     * @request GET:/api/ai-report-publish-templates/{templateId}
     * @secure
     */
    getAsync: (templateId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/ai-service/api/ai-report-publish-templates/${templateId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReportPublishTemplate
     * @name UpdateAsync
     * @request PUT:/api/ai-report-publish-templates/{templateId}
     * @secure
     */
    updateAsync: (templateId: number, data: UpdatePublishTemplateRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/ai-service/api/ai-report-publish-templates/${templateId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReportPublishTemplate
     * @name DeleteAsync
     * @request DELETE:/api/ai-report-publish-templates/{templateId}
     * @secure
     */
    deleteAsync: (templateId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/ai-service/api/ai-report-publish-templates/${templateId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReportPublishTemplate
     * @name GetAllByAiObjectAsync
     * @request GET:/api/ai-report-publish-templates/ai-object/{aiObjectId}
     * @secure
     */
    getAllByAiObjectAsync: (aiObjectId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/ai-service/api/ai-report-publish-templates/ai-object/${aiObjectId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReportPublishTemplate
     * @name CreateAsync
     * @request POST:/api/ai-report-publish-templates
     * @secure
     */
    createAsync: (data: CreatePublishTemplateRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/ai-service/api/ai-report-publish-templates`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  aiReports = {
    /**
     * No description
     *
     * @tags AIReports
     * @name GetAiObjectAnalysisAsync
     * @request POST:/api/ai-reports/content/{contentId}/ai-object/{aiObjectId}
     * @secure
     */
    getAiObjectAnalysisAsync: (
      contentId: number,
      aiObjectId: number,
      data: GetAIObjectAnalysisRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, void>({
        path: `/ai-service/api/ai-reports/content/${contentId}/ai-object/${aiObjectId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReports
     * @name GetPublishNameAsync
     * @request GET:/api/ai-reports/ai-object/{aiObjectId}/publish-name
     * @secure
     */
    getPublishNameAsync: (aiObjectId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/ai-service/api/ai-reports/ai-object/${aiObjectId}/publish-name`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReports
     * @name PublishAsync
     * @request POST:/api/ai-reports/content/{contentId}/ai-object/{aiObjectId}/publish
     * @secure
     */
    publishAsync: (contentId: number, aiObjectId: number, data: PublishAIReportRequest, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/ai-service/api/ai-reports/content/${contentId}/ai-object/${aiObjectId}/publish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AIReports
     * @name UpdateUniqueAiObject
     * @request PUT:/api/ai-reports/unique-ai-object/{uniqueAIObjectId}
     * @secure
     */
    updateUniqueAiObject: (
      uniqueAiObjectId: string,
      data: UniqueAIObjectExternalUpdateRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<void, void>({
        path: `/ai-service/api/ai-reports/unique-ai-object/${uniqueAiObjectId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
  annotationAiObjects = {
    /**
     * No description
     *
     * @tags AnnotationAIObjects
     * @name GetAnnotationTextAsync
     * @request GET:/api/annotation-ai-objects/annotation/{annotationId}
     * @secure
     */
    getAnnotationTextAsync: (annotationId: number, params: RequestParams = {}) =>
      this.http.request<AnnotationTextResponse, ApiErrorResponse>({
        path: `/ai-service/api/annotation-ai-objects/annotation/${annotationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AnnotationAIObjects
     * @name GetExistingAsync
     * @request POST:/api/annotation-ai-objects/existing
     * @secure
     */
    getExistingAsync: (data: GetAnnotationAIObjectsRequest, params: RequestParams = {}) =>
      this.http.request<AnnotationAIObjectResponse[], ApiErrorResponse | void>({
        path: `/ai-service/api/annotation-ai-objects/existing`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AnnotationAIObjects
     * @name GetAnnotationUniqueAiObjectsAsync
     * @request POST:/api/annotation-ai-objects/unique
     * @secure
     */
    getAnnotationUniqueAiObjectsAsync: (data: GetAnnotationUniqueAIObjectsRequest, params: RequestParams = {}) =>
      this.http.request<AnnotationUniqueAIObjectResponse[], ApiErrorResponse | void>({
        path: `/ai-service/api/annotation-ai-objects/unique`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  formControlTags = {
    /**
     * No description
     *
     * @tags FormControlTags
     * @name GetByFormControlIdsAsync
     * @request GET:/api/form-control-tags
     * @secure
     */
    getByFormControlIdsAsync: (
      query: {
        /** @minItems 1 */
        fcIds: number[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormControlTagResponse[], ApiErrorResponse>({
        path: `/ai-service/api/form-control-tags`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormControlTags
     * @name PostAsync
     * @request POST:/api/form-control-tags
     * @secure
     */
    postAsync: (data: FormControlTagCreateRequest, params: RequestParams = {}) =>
      this.http.request<FormControlTagResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/form-control-tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormControlTags
     * @name AddNewTagToFormControlAsync
     * @request POST:/api/form-control-tags/new-tag
     * @secure
     */
    addNewTagToFormControlAsync: (data: FormControlNewTagCreateRequest, params: RequestParams = {}) =>
      this.http.request<FormControlTagResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/form-control-tags/new-tag`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormControlTags
     * @name DeleteAsync
     * @request DELETE:/api/form-control-tags/{formControlTagId}
     * @secure
     */
    deleteAsync: (formControlTagId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/ai-service/api/form-control-tags/${formControlTagId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  iterationMetrics = {
    /**
     * No description
     *
     * @tags IterationMetrics
     * @name GetByIterationAsync
     * @request GET:/api/iteration-metrics/iteration/{iterationId}
     * @secure
     */
    getByIterationAsync: (iterationId: number, params: RequestParams = {}) =>
      this.http.request<IterationMetricResponse[], ApiErrorResponse>({
        path: `/ai-service/api/iteration-metrics/iteration/${iterationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags IterationMetrics
     * @name DownloadIterationMetricsAsync
     * @request POST:/api/iteration-metrics/iteration/{iterationId}/download
     * @secure
     */
    downloadIterationMetricsAsync: (iterationId: number, params: RequestParams = {}) =>
      this.http.request<IterationResponse[], ApiErrorResponse>({
        path: `/ai-service/api/iteration-metrics/iteration/${iterationId}/download`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  iterations = {
    /**
     * No description
     *
     * @tags Iterations
     * @name GetByProjectAsync
     * @request GET:/api/iterations/project/{projectId}
     * @secure
     */
    getByProjectAsync: (projectId: number, params: RequestParams = {}) =>
      this.http.request<IterationResponse[], ApiErrorResponse>({
        path: `/ai-service/api/iterations/project/${projectId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iterations
     * @name GetByIdAsync
     * @request GET:/api/iterations/{iterationId}
     * @secure
     */
    getByIdAsync: (iterationId: number, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse>({
        path: `/ai-service/api/iterations/${iterationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iterations
     * @name PutAsync
     * @request PUT:/api/iterations
     * @secure
     */
    putAsync: (data: IterationUpdateRequest, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/iterations`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iterations
     * @name GetPagesByIterationIdAsync
     * @request GET:/api/iterations/pages
     * @secure
     */
    getPagesByIterationIdAsync: (
      query: {
        /** @format int32 */
        iterationId: number
        /**
         * @format int32
         * @default 1
         */
        pageNumber?: number
        /**
         * @format int32
         * @default 20
         */
        pageSize?: number
        /** @default false */
        isExcluded?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.http.request<PageForIterationResponsePaginatedPagesResponse, ApiErrorResponse>({
        path: `/ai-service/api/iterations/pages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iterations
     * @name GetFiltersByIterationIdAsync
     * @request GET:/api/iterations/{iterationId}/filters
     * @secure
     */
    getFiltersByIterationIdAsync: (iterationId: number, params: RequestParams = {}) =>
      this.http.request<(IterationFormFiltersResponse | IterationAnnotationFiltersResponse)[], ApiErrorResponse>({
        path: `/ai-service/api/iterations/${iterationId}/filters`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iterations
     * @name GetStatusAsync
     * @request GET:/api/iterations/{iterationId}/status
     * @secure
     */
    getStatusAsync: (iterationId: number, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse>({
        path: `/ai-service/api/iterations/${iterationId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Iterations
     * @name GetDeploymentStatusAsync
     * @request GET:/api/iterations/{iterationId}/status/deployment
     * @secure
     */
    getDeploymentStatusAsync: (iterationId: number, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse>({
        path: `/ai-service/api/iterations/${iterationId}/status/deployment`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  nlpModels = {
    /**
     * No description
     *
     * @tags NLPModels
     * @name GetAllAsync
     * @request GET:/api/nlp-models
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<NLPModelResponse[], any>({
        path: `/ai-service/api/nlp-models`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NLPModels
     * @name PostAsync
     * @request POST:/api/nlp-models
     * @secure
     */
    postAsync: (data: NLPModelCreateRequest, params: RequestParams = {}) =>
      this.http.request<NLPModelResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/nlp-models`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NLPModels
     * @name PutAsync
     * @request PUT:/api/nlp-models
     * @secure
     */
    putAsync: (data: NLPModelUpdateRequest, params: RequestParams = {}) =>
      this.http.request<NLPModelResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/nlp-models`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NLPModels
     * @name GetAsync
     * @request GET:/api/nlp-models/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<NLPModelResponse, ApiErrorResponse>({
        path: `/ai-service/api/nlp-models/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags NLPModels
     * @name DeleteAsync
     * @request DELETE:/api/nlp-models/{modelId}
     * @secure
     */
    deleteAsync: (modelId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/ai-service/api/nlp-models/${modelId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  predictionSets = {
    /**
     * No description
     *
     * @tags PredictionSets
     * @name GetAsync
     * @request GET:/api/prediction-sets/{predictionSetId}
     * @secure
     */
    getAsync: (predictionSetId: number, params: RequestParams = {}) =>
      this.http.request<PredictionSetWithAIModelResponse, ApiErrorResponse>({
        path: `/ai-service/api/prediction-sets/${predictionSetId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PredictionSets
     * @name DeleteAsync
     * @request DELETE:/api/prediction-sets/{predictionSetId}
     * @secure
     */
    deleteAsync: (predictionSetId: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/ai-service/api/prediction-sets/${predictionSetId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PredictionSets
     * @name PutAsync
     * @request PUT:/api/prediction-sets
     * @secure
     */
    putAsync: (data: PredictionSetUpdateRequest, params: RequestParams = {}) =>
      this.http.request<PredictionSetUpdateRequest, ApiErrorResponse | void>({
        path: `/ai-service/api/prediction-sets`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  projects = {
    /**
     * No description
     *
     * @tags Projects
     * @name PostAsync
     * @request POST:/api/projects
     * @secure
     */
    postAsync: (data: ProjectCreateRequest, params: RequestParams = {}) =>
      this.http.request<ProjectResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/projects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name PutAsync
     * @request PUT:/api/projects
     * @secure
     */
    putAsync: (data: ProjectUpdateRequest, params: RequestParams = {}) =>
      this.http.request<ProjectResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/projects`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name GetAllAsync
     * @request GET:/api/projects
     * @secure
     */
    getAllAsync: (
      query?: {
        Name?: string
        Description?: string
        /**
         *
         *
         * 0 = VQA
         *
         * 100 = ImageClassification
         *
         * 101 = ObjectDetection
         */
        Type?: ProjectType
        /**
         *
         *
         * 1 = Name
         *
         * 2 = Description
         *
         * 3 = CreatedOn
         *
         * 4 = Type
         */
        Column?: ProjectsSortingColumnEnum
        /**
         *
         *
         * 1 = asc
         *
         * 2 = desc
         */
        Order?: SortingOrder
        /**
         * @format int32
         * @default 1
         */
        PageNumber?: number
        /**
         * @format int32
         * @default 25
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ProjectResponsePagenatedProjectsResponse[], ApiErrorResponse>({
        path: `/ai-service/api/projects`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name GetAsync
     * @request GET:/api/projects/{projectId}
     * @secure
     */
    getAsync: (projectId: number, params: RequestParams = {}) =>
      this.http.request<ProjectResponse[], ApiErrorResponse>({
        path: `/ai-service/api/projects/${projectId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name DeleteAsync
     * @request DELETE:/api/projects/{projectId}
     * @secure
     */
    deleteAsync: (projectId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/ai-service/api/projects/${projectId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  projectTraining = {
    /**
     * No description
     *
     * @tags ProjectTraining
     * @name PostStartAsync
     * @request POST:/api/project-training/train/start
     * @secure
     */
    postStartAsync: (data: ProjectTrainStartRequest, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/train/start`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name PostStatusAsync
     * @request POST:/api/project-training/train/status
     * @secure
     */
    postStatusAsync: (data: ProjectTrainingUpdateStatusRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/train/status`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name PostDeployStatusAsync
     * @request POST:/api/project-training/deploy/status
     * @secure
     */
    postDeployStatusAsync: (data: ProjectTrainingUpdateDeploymentStatusRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/deploy/status`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name PostStartDeployAsync
     * @request POST:/api/project-training/deploy/start
     * @secure
     */
    postStartDeployAsync: (data: IterationDeployRequest, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/deploy/start`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name PostStartDeployByAiModelAsync
     * @request POST:/api/project-training/deploy/start/ai-model
     * @secure
     */
    postStartDeployByAiModelAsync: (data: IterationDeployStartByAIModelRequest, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/deploy/start/ai-model`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name PostStartDeployByVqaModelAsync
     * @request POST:/api/project-training/deploy/start/vqa-model
     * @secure
     */
    postStartDeployByVqaModelAsync: (data: IterationDeployStartByVQAModelRequest, params: RequestParams = {}) =>
      this.http.request<IterationResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/deploy/start/vqa-model`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name GetPagesAiObjectsStatisticsForProjectAsync
     * @request POST:/api/project-training/pages/statistics/aiObjects
     * @secure
     */
    getPagesAiObjectsStatisticsForProjectAsync: (
      data: PagesStatisticsByAIObjectsForProjectGetRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<PagesStatisticsByAIObjectsForProjectResponse[], ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/pages/statistics/aiObjects`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name GetPagesFormsStatisticsForProjectAsync
     * @request POST:/api/project-training/pages/statistics/forms
     * @secure
     */
    getPagesFormsStatisticsForProjectAsync: (
      data: PagesStatisticsByFormsForProjectGetRequest,
      params: RequestParams = {}
    ) =>
      this.http.request<PagesStatisticsByFormsForProjectResponse[], ApiErrorResponse | void>({
        path: `/ai-service/api/project-training/pages/statistics/forms`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name GetContentsForProjectAsync
     * @request GET:/api/project-training/project/contents
     * @secure
     */
    getContentsForProjectAsync: (
      query?: {
        /** @format int32 */
        pageNumber?: number
        /** @format int32 */
        pageSize?: number
        searchQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<ContentForProjectResponse[], any>({
        path: `/ai-service/api/project-training/project/contents`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name GetFormControlsForProjectAsync
     * @request GET:/api/project-training/project/form-controls
     * @secure
     */
    getFormControlsForProjectAsync: (
      query?: {
        /** @format int32 */
        pageNumber?: number
        /** @format int32 */
        pageSize?: number
        searchQuery?: string
        contentIds?: number[]
        formIds?: number[]
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormControlForProjectResponse[], any>({
        path: `/ai-service/api/project-training/project/form-controls`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProjectTraining
     * @name GetFormsForProjectAsync
     * @request GET:/api/project-training/project/forms
     * @secure
     */
    getFormsForProjectAsync: (
      query?: {
        /** @format int32 */
        pageNumber?: number
        /** @format int32 */
        pageSize?: number
        searchQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.http.request<FormForProjectResponse[], any>({
        path: `/ai-service/api/project-training/project/forms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  selectionListItems = {
    /**
     * No description
     *
     * @tags SelectionListItems
     * @name GetBySelectionListIdAsync
     * @request GET:/api/selection-list-items/{selectionListId}
     * @secure
     */
    getBySelectionListIdAsync: (selectionListId: number, params: RequestParams = {}) =>
      this.http.request<SelectionListItemResponse[], ApiErrorResponse>({
        path: `/ai-service/api/selection-list-items/${selectionListId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  selectionLists = {
    /**
     * No description
     *
     * @tags SelectionLists
     * @name GetAllAsync
     * @request GET:/api/selection-lists
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<SelectionListResponse[], ApiErrorResponse>({
        path: `/ai-service/api/selection-lists`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SelectionLists
     * @name CreateAsync
     * @request POST:/api/selection-lists
     * @secure
     */
    createAsync: (data: SelectionListCreateRequest, params: RequestParams = {}) =>
      this.http.request<SelectionListResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/selection-lists`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SelectionLists
     * @name GetByIdAsync
     * @request GET:/api/selection-lists/{id}
     * @secure
     */
    getByIdAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<SelectionListResponse, ApiErrorResponse>({
        path: `/ai-service/api/selection-lists/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SelectionLists
     * @name UpdateAsync
     * @request PUT:/api/selection-lists/{id}
     * @secure
     */
    updateAsync: (id: number, data: SelectionListUpdateRequest, params: RequestParams = {}) =>
      this.http.request<SelectionListResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/selection-lists/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SelectionLists
     * @name DeleteAsync
     * @request DELETE:/api/selection-lists/{id}
     * @secure
     */
    deleteAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse>({
        path: `/ai-service/api/selection-lists/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
  tags = {
    /**
     * No description
     *
     * @tags Tags
     * @name GetAllAsync
     * @request GET:/api/tags
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<TagResponse[], any>({
        path: `/ai-service/api/tags`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name CreateAsync
     * @request POST:/api/tags
     * @secure
     */
    createAsync: (data: TagCreateRequest, params: RequestParams = {}) =>
      this.http.request<TagResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/tags`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
  uniqueAiObjects = {
    /**
     * No description
     *
     * @tags UniqueAIObjects
     * @name PutAsync
     * @request PUT:/api/unique-ai-objects/external
     * @secure
     */
    putAsync: (data: UniqueAIObjectExternalUpdateRequest, params: RequestParams = {}) =>
      this.http.request<UniqueAIObjectResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/unique-ai-objects/external`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UniqueAIObjects
     * @name AutofillPageUniqueAiObjectsAsync
     * @request PUT:/api/unique-ai-objects/autofill
     * @secure
     */
    autofillPageUniqueAiObjectsAsync: (data: UniqueAIObjectsAutofillRequest, params: RequestParams = {}) =>
      this.http.request<UniqueAIObjectResponse[], ApiErrorResponse | void>({
        path: `/ai-service/api/unique-ai-objects/autofill`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UniqueAIObjects
     * @name SearchUniqueObjectsAsync
     * @request GET:/api/unique-ai-objects/content/{contentId}/search
     * @secure
     */
    searchUniqueObjectsAsync: (
      contentId: number,
      query?: {
        AIObjectIds?: number[]
        Search?: string
        /**
         * @format int32
         * @default 1
         */
        PageNumber?: number
        /**
         * @format int32
         * @default 25
         */
        PageSize?: number
      },
      params: RequestParams = {}
    ) =>
      this.http.request<UniqueAIObjectWithAIObjectResponse[], ApiErrorResponse>({
        path: `/ai-service/api/unique-ai-objects/content/${contentId}/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  utilityInfrastructure = {
    /**
     * No description
     *
     * @tags UtilityInfrastructure
     * @name RunAnalysisWorkflowAsync
     * @request POST:/api/utility-infrastructure/run-analysis
     * @secure
     */
    runAnalysisWorkflowAsync: (data: UtilityInfrastructureAnalysisRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/utility-infrastructure/run-analysis`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UtilityInfrastructure
     * @name GetPolesUniqueObjectsByContentAsync
     * @request GET:/api/utility-infrastructure/{contentId}/poles
     * @secure
     */
    getPolesUniqueObjectsByContentAsync: (contentId: number, params: RequestParams = {}) =>
      this.http.request<any, ApiErrorResponse>({
        path: `/ai-service/api/utility-infrastructure/${contentId}/poles`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  }
  vqaModels = {
    /**
     * No description
     *
     * @tags VQAModels
     * @name GetAllAsync
     * @request GET:/api/vqa-models
     * @secure
     */
    getAllAsync: (params: RequestParams = {}) =>
      this.http.request<VQAModelListResponse[], any>({
        path: `/ai-service/api/vqa-models`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name PostAsync
     * @request POST:/api/vqa-models
     * @secure
     */
    postAsync: (data: VQAModelCreateRequest, params: RequestParams = {}) =>
      this.http.request<VQAModelResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/vqa-models`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name PutAsync
     * @request PUT:/api/vqa-models
     * @secure
     */
    putAsync: (data: VQAModelUpdateRequest, params: RequestParams = {}) =>
      this.http.request<VQAModelResponse, ApiErrorResponse | void>({
        path: `/ai-service/api/vqa-models`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name GetAsync
     * @request GET:/api/vqa-models/{id}
     * @secure
     */
    getAsync: (id: number, params: RequestParams = {}) =>
      this.http.request<VQAModelResponse, ApiErrorResponse>({
        path: `/ai-service/api/vqa-models/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name DeleteAsync
     * @request DELETE:/api/vqa-models/{modelId}
     * @secure
     */
    deleteAsync: (modelId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/ai-service/api/vqa-models/${modelId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name GetByFormIdAsync
     * @request GET:/api/vqa-models/form/{formId}
     * @secure
     */
    getByFormIdAsync: (formId: number, params: RequestParams = {}) =>
      this.http.request<VQAModelShortResponse[], VQAModelShortResponse>({
        path: `/ai-service/api/vqa-models/form/${formId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name GetForFormAsync
     * @request GET:/api/vqa-models/form
     * @secure
     */
    getForFormAsync: (params: RequestParams = {}) =>
      this.http.request<VQAModelShortResponse[], any>({
        path: `/ai-service/api/vqa-models/form`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name AddToFormAsync
     * @request POST:/api/vqa-models/form/{formId}/{vqaModelId}
     * @secure
     */
    addToFormAsync: (formId: number, vqaModelId: number, params: RequestParams = {}) =>
      this.http.request<VQAModelFormResponse, ApiErrorResponse>({
        path: `/ai-service/api/vqa-models/form/${formId}/${vqaModelId}`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name DeleteFromFormAsync
     * @request DELETE:/api/vqa-models/form/{formId}/{vqaModelId}
     * @secure
     */
    deleteFromFormAsync: (formId: number, vqaModelId: number, params: RequestParams = {}) =>
      this.http.request<number, ApiErrorResponse>({
        path: `/ai-service/api/vqa-models/form/${formId}/${vqaModelId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name PublishAsync
     * @request POST:/api/vqa-models/{vqaModelId}/publish
     * @secure
     */
    publishAsync: (vqaModelId: number, data: AIModelPublishRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/vqa-models/${vqaModelId}/publish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags VQAModels
     * @name UnpublishAsync
     * @request POST:/api/vqa-models/{vqaModelId}/unpublish
     * @secure
     */
    unpublishAsync: (vqaModelId: number, data: AIModelPublishRequest, params: RequestParams = {}) =>
      this.http.request<void, ApiErrorResponse | void>({
        path: `/ai-service/api/vqa-models/${vqaModelId}/unpublish`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  }
}
